import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Review0Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Review0IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7197 21C17.6903 21 21.7197 16.9706 21.7197 12C21.7197 7.02944 17.6903 3 12.7197 3C7.74916 3 3.71973 7.02944 3.71973 12C3.71973 16.9706 7.74916 21 12.7197 21ZM12.7197 22C18.2426 22 22.7197 17.5228 22.7197 12C22.7197 6.47715 18.2426 2 12.7197 2C7.19688 2 2.71973 6.47715 2.71973 12C2.71973 17.5228 7.19688 22 12.7197 22Z"
        fill="url(#paint0_linear_7623_96)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7623_96"
          x1="2.71973"
          y1="13.8478"
          x2="22.7197"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Review0Icon;
